import dayjs from 'dayjs'

const OUTCOME_TYPES = {
  ADMINISTERED: 'ADMINISTERED',
  VERBAL_PROMPT: 'VERBAL_PROMPT',
  ABSENT: 'ABSENT',
  OTHER: 'OTHER',
  ALREADY_TAKEN: 'ALREADY_TAKEN',
  NOT_SCHEDULED_OR_NOT_NEEDED: 'NOT_SCHEDULED_OR_NOT_NEEDED',
  LEFT_OUT: 'LEFT_OUT',
  PAUSED: 'PAUSED',
  NAUSEA_OR_VOMITING: 'NAUSEA_OR_VOMITING',
  DISCONTINUED: 'DISCONTINUED',
  REFUSED: 'REFUSED',
  MISSED: 'MISSED',
  REFUSED_AND_DESTROYED: 'REFUSED_AND_DESTROYED'
}

export const generateMockData = (
  showHourColumn: boolean,
  datesArray: any[],
  type: 'scheduled' | 'prn'
) => {
  const mockData: any[] = []

  const scheduledMedications = [
    {
      name: 'Amoxapine 50mg tablets',
      hour: '08:00',
      dose: '1',
      currentStock: 12,
      startDate: '01-05-2025',
      endDate: '31-02-2026',
      isControlledDrug: true
    },
    {
      name: 'Paracetamol 500mg tablets',
      hour: '12:00',
      dose: '2',
      currentStock: 45,
      startDate: '15-03-2025',
      endDate: '15-03-2026',
      isControlledDrug: false
    },
    {
      name: 'Ibuprofen 200mg tablets',
      hour: '18:00',
      dose: '1',
      currentStock: 30,
      startDate: '01-01-2025',
      endDate: '31-12-2025',
      isControlledDrug: false
    },
    {
      name: 'Metformin 500mg tablets',
      hour: '10:00',
      dose: '2',
      currentStock: 60,
      startDate: '01-01-2025',
      endDate: '31-12-2025',
      isControlledDrug: false
    },
    {
      name: 'Omeprazole 20mg tablets',
      hour: '07:00',
      dose: '1',
      currentStock: 40,
      startDate: '01-01-2025',
      endDate: '31-12-2025',
      isControlledDrug: false
    },
    {
      name: 'Lisinopril 10mg tablets',
      hour: '08:00',
      dose: '1',
      currentStock: 35,
      startDate: '01-01-2025',
      endDate: '31-12-2025',
      isControlledDrug: false
    },
    {
      name: 'Atorvastatin 20mg tablets',
      hour: '20:00',
      dose: '1',
      currentStock: 28,
      startDate: '01-01-2025',
      endDate: '31-12-2025',
      isControlledDrug: false
    },
    {
      name: 'Amlodipine 5mg tablets',
      hour: '09:00',
      dose: '1',
      currentStock: 50,
      startDate: '01-01-2025',
      endDate: '31-12-2025',
      isControlledDrug: false
    }
  ]

  const prnMedications = [
    {
      name: 'Paracetamol 500mg tablets (PRN)',
      hour: '',
      dose: '1-2',
      currentStock: 45,
      startDate: '15-03-2025',
      endDate: '15-03-2026',
      isControlledDrug: false
    },
    {
      name: 'Ibuprofen 200mg tablets (PRN)',
      hour: '',
      dose: '1-2',
      currentStock: 30,
      startDate: '01-01-2025',
      endDate: '31-12-2025',
      isControlledDrug: false
    },
    {
      name: 'Morphine 10mg tablets (PRN)',
      hour: '',
      dose: '1',
      currentStock: 15,
      startDate: '01-01-2025',
      endDate: '31-12-2025',
      isControlledDrug: true
    },
    {
      name: 'Lorazepam 1mg tablets (PRN)',
      hour: '',
      dose: '0.5-1',
      currentStock: 20,
      startDate: '01-01-2025',
      endDate: '31-12-2025',
      isControlledDrug: true
    },
    {
      name: 'Senna tablets (PRN)',
      hour: '',
      dose: '2',
      currentStock: 40,
      startDate: '01-01-2025',
      endDate: '31-12-2025',
      isControlledDrug: false
    }
  ]

  const medications =
    type === 'scheduled' ? scheduledMedications : prnMedications

  const allOutcomes = [
    OUTCOME_TYPES.ADMINISTERED,
    OUTCOME_TYPES.VERBAL_PROMPT,
    OUTCOME_TYPES.ABSENT,
    OUTCOME_TYPES.OTHER,
    OUTCOME_TYPES.ALREADY_TAKEN,
    OUTCOME_TYPES.NOT_SCHEDULED_OR_NOT_NEEDED,
    OUTCOME_TYPES.LEFT_OUT,
    OUTCOME_TYPES.PAUSED,
    OUTCOME_TYPES.NAUSEA_OR_VOMITING,
    OUTCOME_TYPES.DISCONTINUED,
    OUTCOME_TYPES.REFUSED,
    OUTCOME_TYPES.MISSED,
    OUTCOME_TYPES.REFUSED_AND_DESTROYED
  ]

  medications.forEach((med, index) => {
    const row: any = {
      key: `med-${index}`,
      medication: {
        name: med.name,
        currentStock: med.currentStock,
        startDate: med.startDate,
        endDate: med.endDate,
        isControlledDrug: med.isControlledDrug,
        lowStock: med.currentStock <= 20 && med.currentStock > 0,
        outOfStock: med.currentStock === 0
      },
      dose: med.dose
    }

    if (showHourColumn) {
      row.hour = med.hour
    }

    let dateCounter = 0
    datesArray.forEach(({ days }) => {
      days.forEach((dateString: string) => {
        const dateKey = dayjs(dateString, 'DD/MM/YYYY').format('DD-MM-YYYY')
        const date = dayjs(dateString, 'DD/MM/YYYY')

        let outcomeType = OUTCOME_TYPES.ADMINISTERED

        if (type === 'scheduled') {
          const random = Math.random()
          if (random < 0.85) {
            outcomeType = OUTCOME_TYPES.ADMINISTERED
          } else if (random < 0.87) {
            outcomeType = OUTCOME_TYPES.VERBAL_PROMPT
          } else if (random < 0.89) {
            outcomeType = OUTCOME_TYPES.ABSENT
          } else if (random < 0.91) {
            outcomeType = OUTCOME_TYPES.OTHER
          } else if (random < 0.93) {
            outcomeType = OUTCOME_TYPES.ALREADY_TAKEN
          } else if (random < 0.94) {
            outcomeType = OUTCOME_TYPES.NOT_SCHEDULED_OR_NOT_NEEDED
          } else if (random < 0.95) {
            outcomeType = OUTCOME_TYPES.LEFT_OUT
          } else if (random < 0.96) {
            outcomeType = OUTCOME_TYPES.PAUSED
          } else if (random < 0.97) {
            outcomeType = OUTCOME_TYPES.NAUSEA_OR_VOMITING
          } else if (random < 0.98) {
            outcomeType = OUTCOME_TYPES.DISCONTINUED
          } else if (random < 0.99) {
            outcomeType = OUTCOME_TYPES.REFUSED
          } else {
            outcomeType = OUTCOME_TYPES.MISSED
          }
        } else {
          const random = Math.random()
          if (random < 0.6) {
            outcomeType = OUTCOME_TYPES.ADMINISTERED
          } else if (random < 0.65) {
            outcomeType = OUTCOME_TYPES.REFUSED
          } else if (random < 0.7) {
            outcomeType = OUTCOME_TYPES.NOT_SCHEDULED_OR_NOT_NEEDED
          } else if (random < 0.75) {
            outcomeType = OUTCOME_TYPES.MISSED
          } else if (random < 0.8) {
            outcomeType = OUTCOME_TYPES.PAUSED
          } else if (random < 0.85) {
            outcomeType = OUTCOME_TYPES.DISCONTINUED
          } else if (random < 0.9) {
            outcomeType = OUTCOME_TYPES.VERBAL_PROMPT
          } else if (random < 0.93) {
            outcomeType = OUTCOME_TYPES.ABSENT
          } else if (random < 0.96) {
            outcomeType = OUTCOME_TYPES.ALREADY_TAKEN
          } else {
            outcomeType = OUTCOME_TYPES.OTHER
          }
        }

        dateCounter++

        const isToday = date.isSame(dayjs(), 'day')
        if (!isToday || outcomeType === OUTCOME_TYPES.ADMINISTERED) {
          const outcome: any = {
            action: outcomeType,
            date: dateKey
          }

          if (outcomeType === OUTCOME_TYPES.ADMINISTERED) {
            outcome.recordDetails = {
              quantity: med.dose,
              timeRecorded: date
                .hour(parseInt(med.hour?.split(':')[0] || '8'))
                .minute(parseInt(med.hour?.split(':')[1] || '0'))
                .toISOString(),
              recordedBy: 'John Doe',
              witnessedBy: index % 2 === 0 ? 'Jane Smith' : undefined
            }
          } else if (outcomeType === OUTCOME_TYPES.PAUSED) {
            outcome.recordDetails = {
              pauseDate: date
                .hour(parseInt(med.hour?.split(':')[0] || '8'))
                .minute(parseInt(med.hour?.split(':')[1] || '0'))
                .toISOString(),
              continueDate: date
                .add(7, 'days')
                .hour(parseInt(med.hour?.split(':')[0] || '8'))
                .minute(parseInt(med.hour?.split(':')[1] || '0'))
                .toISOString(),
              reason: 'Vacation with the family',
              timeRecorded: date
                .hour(parseInt(med.hour?.split(':')[0] || '8'))
                .minute(parseInt(med.hour?.split(':')[1] || '0'))
                .toISOString(),
              recordedBy: 'John Doe',
              witnessedBy: index % 2 === 0 ? 'Jane Smith' : undefined
            }
          } else if (outcomeType === OUTCOME_TYPES.REFUSED) {
            outcome.recordDetails = {
              stockChanged: index % 2 === 0,
              stockRemoved: index % 2 === 0 ? '1 tablet' : undefined,
              comment:
                'Freddy refused medication due to his behaviour problems.',
              timeRecorded: date
                .hour(parseInt(med.hour?.split(':')[0] || '8'))
                .minute(parseInt(med.hour?.split(':')[1] || '0'))
                .toISOString(),
              recordedBy: 'John Doe',
              witnessedBy: index % 2 === 0 ? 'Jane Smith' : undefined
            }
          } else if (outcomeType === OUTCOME_TYPES.DISCONTINUED) {
            outcome.recordDetails = {
              timeRecorded: date
                .hour(parseInt(med.hour?.split(':')[0] || '8'))
                .minute(parseInt(med.hour?.split(':')[1] || '0'))
                .toISOString(),
              recordedBy: 'John Doe',
              witnessedBy: index % 2 === 0 ? 'Jane Smith' : undefined
            }
          } else if (
            outcomeType === OUTCOME_TYPES.NOT_SCHEDULED_OR_NOT_NEEDED
          ) {
            outcome.recordDetails = {
              comment: 'Medication was not needed for the day',
              timeRecorded: date
                .hour(parseInt(med.hour?.split(':')[0] || '8'))
                .minute(parseInt(med.hour?.split(':')[1] || '0'))
                .toISOString(),
              recordedBy: 'John Doe',
              witnessedBy: index % 2 === 0 ? 'Jane Smith' : undefined
            }
          }

          row[dateKey] = {
            outcomes: [outcome]
          }
        }
      })
    })

    mockData.push(row)
  })

  return mockData
}
